import React, { Component } from "react";
import Title from "./../Title";
import Card from "./../Card";
import CardContainer from "./../CardContainer";
import Loading from "../Loading";
import "./index.scss";

//Redux
import { connect } from "react-redux";
import PropTypes from "prop-types";
import {
  getMaxHeightExpanded,
  setMaxHeightExpanded,
  changeMenu
} from "./../../actions/themeActions";
import { getServices } from "./../../actions/dataActions";

class index extends Component {
  maxHeight = () => {
    const { setMaxHeightExpanded, getMaxHeightExpanded } = this.props;
    let MAX_HEIGHT_EXPANDED;

    if (window.innerWidth > 895) {
      MAX_HEIGHT_EXPANDED = `${document.body.clientHeight -
        document.getElementById("header").offsetHeight -
        document.querySelector(".section").offsetHeight -
        180}`;
    }

    setMaxHeightExpanded(MAX_HEIGHT_EXPANDED);
    getMaxHeightExpanded();
  };

  componentDidMount() {
    this.props.changeMenu(this.props.location.pathname.slice(1));
    this.maxHeight();
    window.addEventListener("resize", this.maxHeight);
    this.props.getServices();
  }

  render() {
    const { id } = this.props.match.params;
    const {
      services,
      theme,
      maxHeightExpanded,
      showMenu,
      loadingServices
    } = this.props;

    return (
      <div id="ServicesCatalog" className={showMenu ? `blur` : ""}>
        <Title text={`Catálogo de serviços`} type={`SECTION`} theme={theme} />
        {loadingServices ? (
          <Loading />
        ) : id ? (
          <div className="line">
            <Card
              title={services[id].name}
              subTitle={services[id].parent}
              type={"expanded"}
              icon={services[id].icone}
              description={services[id].description}
              targetAudience={services[id].targetAudience}
              theme={theme}
              maxHeightExpanded={maxHeightExpanded}
            />
          </div>
        ) : (
          <CardContainer data={services} theme={theme} />
        )}
      </div>
    );
  }
}

index.propTypes = {
  getServices: PropTypes.func.isRequired,
  theme: PropTypes.string.isRequired,
  services: PropTypes.array.isRequired,
  loadingServices: PropTypes.bool.isRequired,
  showMenu: PropTypes.bool.isRequired,
  changeMenu: PropTypes.func.isRequired,
  getMaxHeightExpanded: PropTypes.func.isRequired,
  setMaxHeightExpanded: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  theme: state.theme.theme,
  services: state.data.services,
  loadingServices: state.data.loadingServices,
  maxHeightExpanded: state.theme.maxHeightExpanded,
  showMenu: state.theme.showMenu
});

export default connect(
  mapStateToProps,
  { changeMenu, getServices, getMaxHeightExpanded, setMaxHeightExpanded }
)(index);
